import React from "react";
import { Globe2 } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";
import LockedFeatureCard from "@/components/admin/LockedFeatureCard";

export default function SettingsCustomDomains() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Settings" title="Custom domains" description="Run Priya on your own subdomain — e.g. chat.orchidhotel.com." testid="page-settings-custom-domains" />
            <LockedFeatureCard
                title="Custom domains is an Enterprise feature"
                description="Connect chat.orchidhotel.com (or any custom subdomain) so guests see Priya served from your brand domain. Contact sales to enable."
                icon={Globe2}
                badge="Enterprise"
                actionLabel="Contact us"
                testid="custom-domains-locked"
                feature="custom_domains"
            />

            <div className="bg-white border border-stone-200 rounded-lg p-6 mt-6 max-w-3xl opacity-50 pointer-events-none">
                <label className="text-[11px] uppercase tracking-[0.2em] text-stone-500 mb-2 block">
                    Domain
                </label>
                <input
                    placeholder="chat.orchidhotel.com"
                    disabled
                    className="w-full px-3 py-2 rounded-md border border-stone-200 text-sm bg-stone-50"
                />
                <p className="text-xs text-stone-500 mt-2">Use a CNAME record pointing to <span className="font-mono">orchid-chat.cname.fundlezone.com</span>.</p>
            </div>
        </div>
    );
}
